import React from "react";

import "./UserProfileIcon.scss";

const UserProfile = ({ open }) => {
  const getClassName = () => {
    const styleClass = "parent-user-profile";
    const classUser = open ? `${styleClass}-open` : styleClass;
    return classUser;
  };
  return (
    <svg
      id="User_Profile"
      data-name="User Profile"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      className={getClassName()}
    >
      <g id="Group_8562" data-name="Group 8562">
        <rect id="Margin" className="user-profile-cls-1" width="32" height="32" />
        <circle id="Ellipse_71" data-name="Ellipse 71" className="user-profile-cls-2" cx="7" cy="7" r="7" transform="translate(9 9)" />
        <path
          id="Path_8331"
          data-name="Path 8331"
          className="user-profile-cls-3"
          d="M16,15.733A2.53,2.53,0,1,1,18.53,13.2,2.532,2.532,0,0,1,16,15.733Zm0-4.426a1.9,1.9,0,1,0,1.9,1.9A1.9,1.9,0,0,0,16,11.307Z"
        />
        <path
          id="Path_8332"
          data-name="Path 8332"
          className="user-profile-cls-3"
          d="M16,8a8,8,0,1,0,8,8A8.009,8.009,0,0,0,16,8ZM11.448,21.52a4.567,4.567,0,0,1,9.1,0,7.145,7.145,0,0,1-9.1,0Zm9.792-.659a5.338,5.338,0,0,0-10.479,0,7.158,7.158,0,1,1,10.479,0Z"
        />
      </g>
    </svg>
  );
};

export default UserProfile;
